import controller from './live-proximity-card.controller';

const template = require('./live-proximity-card.html');

export default {
    bindings: {
        card: '<',
        canUpdate: '<',
    },
    template,
    controller
};